export default {"src":"https://fishbrain.com/_next/static/media/newHampshire.c453a289.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};